import { Button, Group, TextInput, Modal, Text, Center, Title } from '@mantine/core';
import React from 'react';
import DataTable from 'react-data-table-component';
import ActionCell from './components/ActionCell';
import useGetTypeOfMonth from './useGetTypeOfMonths';
import { useDisclosure } from '@mantine/hooks';
import useCreate from './components/useCreate';
import LoadingErrorContainer from '../../../../components/placeholders/LoadingErrorContainer';
import { useForm, yupResolver } from '@mantine/form';

const Remote = () => {
    const { TypeOfMonthQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch,
        queryKey
    } = useGetTypeOfMonth();

    const [opened, { open, close }] = useDisclosure(false);

    const {
        createMutation
    } = useCreate(queryKey)

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            name: "",

        },

    });
    console.log({ data });
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            width: "200px",
        },

        {
            name: 'Action',
            cell: row => <ActionCell row={row} queryKey={queryKey} />,

            width: "300px",
        },
    ];

    // const handleClick = () => {
    //     navigate('create'); // Adjust the path according to your routing setup
    // };

    const handleCreate = form.onSubmit(async (values) => {
        const formData = new FormData();
        formData.append("name", values?.name);
        createMutation.mutate(formData)
        close();

    });

    return (
        <>
            <LoadingErrorContainer
                isError={isError}
                isLoading={isPending}
                isRefetching={isRefetching}
            >
                <Group justify='space-between'>
                    <Title order={3}>Types of months</Title>
                    <Group >
                        <Button onClick={open} >
                            Create New Type of Month
                        </Button>

                    </Group>
                </Group>
                <DataTable
                    columns={columns}
                    data={data?.data ?? []}
                    progressPending={isPending}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handleChangePerPage}
                    onChangePage={handlePageChange}




                // selectableRows

                />

            </LoadingErrorContainer>
            <Modal opened={opened} onClose={close}
                centered
                title="Add Type of Month">
                <TextInput
                    label="Name"
                    placeholder="Enter Name"
                    key={form.key('name')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name')}
                />

                <Center mt={"md"}>
                    <Button onClick={() => handleCreate()}>
                        Save
                    </Button>
                </Center>

            </Modal >
        </>
    );

}

export default Remote;
